<particle-transfer-box
  [itemsLeft$]="itemsLeft$"
  [itemsRight$]="itemsRight$"
  [fieldDefinitions$]="fieldDefs$"
  [defaultPageSize]="10"
  [availableItemsDisplayText]="'Available Items'"
  [selectedItemsDisplayText]="'Selected Items'"
  (valueChanged)="onValueChange($event)"
>
</particle-transfer-box>
